exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".home[data-v-1e3268b5]{padding:50px}.display-message[data-v-1e3268b5],.home[data-v-1e3268b5]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.display-message[data-v-1e3268b5]{-ms-flex-direction:column;flex-direction:column;width:700px;height:500px;background:#fff;border-radius:20px}.display-message img[data-v-1e3268b5]{height:100px;margin-bottom:100px}.retry-link[data-v-1e3268b5]{margin-top:20px;font-size:1.3rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1e3268b5","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/home/ChargingFeedback.vue
// module id = 849
// module chunks = 0